import { BallAnimation } from "./delivery";
import { Events } from "./game";
import { Tweens } from "phaser";

export class Ball {

    private ballSprite: Phaser.GameObjects.Image;
    private ballShadowSprite: Phaser.GameObjects.Image;


    private currentAnimation: BallAnimation;
    private deliveryTween: Phaser.Tweens.Tween;

    private scene: Phaser.Scene;
    private trailParticles: Phaser.GameObjects.Particles.ParticleEmitter;
    private emitter: Phaser.GameObjects.Particles.ParticleEmitter;


    constructor(ballTexture: string, shadowTexture: string, scene: Phaser.Scene) {

        this.scene = scene;
        this.trailParticles = this.scene.add.particles(100, 300, 'flares', {
            frame: { frames: ['red', 'green', 'blue', 'yellow'], cycle: false },
            scale: { start: 0.2, end: 0.2 },
            blendMode: 'ADD'
          });


        this.ballSprite = scene.add.image(0, 0, ballTexture);
        this.ballShadowSprite = scene.add.image(0, 0, shadowTexture);

        this.ballSprite.setDepth(7);
        this.ballShadowSprite.setDepth(7);
        this.graphics = this.scene.add.graphics();
        this.graphics.setDepth(4);
        this.curve = new Phaser.Curves.Spline();
        // console.log("on ball script");
        //scene.add.existing (this);
    }

    public isTutorial: boolean;
    public perfectShotFrame: number;

    //public pathPoint;
    public graphics;
    public path
    public curve: Phaser.Curves.Spline;
    private particleTween: Tweens.Tween;

    public playAnimation(ballAnimation: BallAnimation, onComplete?: any, speed: number = 1) {
        this.currentAnimation = ballAnimation;

        this.show();

        if (this.deliveryTween != null) {
            this.deliveryTween.stop();
        }

        if (this.emitter) {
            this.emitter.killAll();
        }
        // this.emitter = this.trailParticles.createEmitter({
        //     frame: { frames: ['red', 'green', 'blue', 'yellow'], cycle: false },
        //     scale: { start: 0.5, end: 0.5 },
        //     blendMode: 'ADD'
        // })
        // console.log('this.trailParticles: ', this.trailParticles);
        // this.trailParticles = this.scene.add.particles(100, 300, 'flares', {
        //     frame: { frames: ['red', 'green', 'blue', 'yellow'], cycle: false },
        //     scale: { start: 0.2, end: 0.2 },
        //     blendMode: 'ADD'
        //   });
        this.emitter = this.trailParticles;

        this.curve.points = [];

        let duration = (((this.currentAnimation.positions.length / 60) * (1000)) * speed);

        this.deliveryTween = this.scene.tweens.addCounter({
            from: 0,
            to: this.currentAnimation.positions.length - 1,
            duration: duration,
            ease: 'Linear',
            onComplete: () => {
                if (this.emitter != null) {
                    this.emitter.killAll();
                    this.emitter.stop();
                    this.finishCurve();
                }
                if (onComplete != null)
                    onComplete();
            },
            onUpdate: this.onUpdate.bind(this)
        });
    }

    private finishCurve() {
        //setInterval ()
        this.scene.tweens.addCounter({
            from: 0,
            to: this.curve.points.length,
            onUpdate: () => {
                if (this.curve.points.length > 1) {
                    this.graphics.clear();
                    this.curve.points.splice(0, 1);
                    this.curve.draw(this.graphics);
                }
            },
            duration: 2000
        })
    }

    public emitParticles: boolean;
    private onUpdate() {
        let index = Math.ceil(this.deliveryTween.getValue());
        var x = this.currentAnimation.positions[index].x;
        var y = 1080 - this.currentAnimation.positions[index].y;
        var z = this.currentAnimation.positions[index].z * 0.03;

        this.ballSprite.x = x;
        this.ballSprite.y = y
        this.ballSprite.scale = z;

        this.graphics.clear();
        //this.emitter.setPosition(this.ballSprite.x, this.ballSprite.y);

        if (this.emitParticles) {
            this.emitter.setPosition(this.ballSprite.x, this.ballSprite.y);
            this.emitter.setScale(this.ballSprite.scale);
            this.emitter.emitParticle(5);

            this.graphics.lineStyle(z * 50, 0xffffff, 0.6);

            if (this.curve.points.length < 30) {
                this.curve.addPoint(x, y);
            } else {
                this.curve.points.splice(0, 1);
                this.curve.addPoint(x, y);
            }
            this.curve.draw(this.graphics);


        } else {
            this.emitter.stop();
            // this.hideGraphics();
        }

        if (this.ballSprite.scale < 0.15) {
            this.ballSprite.depth = 4;
            this.graphics.depth = 4;
        } else if (this.ballSprite.scale > 0.15 && this.ballSprite.scale < 0.83) {
            this.ballSprite.depth = 7;
            this.graphics.depth = 6;
        } else if (this.ballSprite.scale > 0.83 && this.ballShadowSprite.scale < 0.87) {
            this.ballSprite.depth = 8;
            this.graphics.depth = 7;
        } else if (this.ballSprite.scale > 0.87 && this.ballShadowSprite.scale < 0.9) {
            this.ballSprite.depth = 9;
            this.graphics.depth = 8;
        } else if (this.ballSprite.scale > 0.9) {
            this.ballSprite.depth = 10;
            this.graphics.depth = 9;
        }

        let ballShadowScale = z;
        this.ballShadowSprite.x = this.currentAnimation.shadowPositions[index].x;
        this.ballShadowSprite.y = 1070 - this.currentAnimation.shadowPositions[index].y;
        this.ballShadowSprite.scale = ballShadowScale;
        this.ballShadowSprite.scale = ballShadowScale;

        if (this.frameUpdateCallback != null) {
            if (this.isTutorial && this.perfectShotFrame == index) {
                this.scene.game.events.emit(Events.OnTutorialMode);
                // console.log('Should pause at this frame');
            }
            this.frameUpdateCallback(index);

        }
    }

    public reset() {
        if (this.deliveryTween != null) {
            this.deliveryTween.stop();
        }
        this.ballSprite.x = this.ballSprite.y = 0;
        this.ballShadowSprite.x = this.ballShadowSprite.y = 0;
        this.ballSprite.scale = 0;

        this.hide();
        this.graphics.clear();
        //if (this.curve != null) {
        // this.curve.points = [];
        // this.curve.addPoint(0, 0);
        // this.curve.draw(this.graphics);
        // console.log ('resetting the ball');
        //}
        if (this.emitter) {
            // this.emitter.setVisible(false);
            this.emitter.stop();
        }

    }

    public hideParticle()
    {
        this.emitter.stop();
        this.emitter.killAll();
    }

    public hide() {
        this.ballSprite.visible = this.ballShadowSprite.visible = false;
    }

    public show() {
        this.ballSprite.visible = this.ballShadowSprite.visible = true;
    }

    public hideGraphics() {
        this.graphics.clear();
    }

    public frameUpdateCallback: (frame: number) => void;
}